import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { LogService } from '../../../../../shared/services/log.service';
import { ObjectToJsonStepperCreatorService } from '../../../../../shared/services/object-to-json-stepper-creator.service';
import { Step1 } from '../../../../../shared/models/component-messages/diveAT/step1';
import { AvisInitialType } from '../../models/AvisInitialType';

@Component({
	selector: 'app-step1',
	templateUrl: './step1.component.html'
})
export class Step1Component implements OnInit {

	private LOG: LogService = new LogService(Step1Component);

	@Input() avisInitial: AvisInitialType;
	@Input() parentForm: FormGroup;
	@Input() disabled: boolean;
	public current_uid = 'AvisInitial';

	@Input() uid = '';

	public step1 = new Step1();

	@Input() linkForRouter: string;

	constructor(
		public objectToJsonStepperCreatorService: ObjectToJsonStepperCreatorService
	) { }

	ngOnInit(): void {
	}

	getUid() {
		return this.uid + '_SepSep_' + this.current_uid;
	}

}
